import React from 'react';
import { useAlert } from '../../context/AlertContext';
import styles from './bars.module.css';

const AlertContainer = () => {
    const { alerts, isModalOpen, clearInfoAlert, clearAlert, clearErrorAlert } = useAlert();

    // Determine container class based on modal state
    const containerClass = isModalOpen ? styles['alert-container-modal'] : styles['alert-container-page'];

    return (
        <div className={containerClass}>
            {alerts.info && (
                <div className={styles['info-bar']}>
                    <span className={styles['alert-content']}>
                        {alerts.info.icon && <span className={styles['alert-icon']}>{alerts.info.icon}</span>}
                        <span className={styles['alert-message']}>
                            {typeof alerts.info === 'string' ? alerts.info : alerts.info.message}
                        </span>
                    </span>
                    <button
                        onClick={clearInfoAlert}
                        className={styles['close-btn']}
                        aria-label="Close info bar"
                    >
                        &times;
                    </button>
                </div>
            )}
            
            {alerts.alert && (
                <div className={`${styles['info-bar']} ${styles['alert-bar']}`}>
                    <span className={styles['alert-content']}>
                        {alerts.alert.icon && <span className={styles['alert-icon']}>{alerts.alert.icon}</span>}
                        <span className={styles['alert-message']}>
                            {typeof alerts.alert === 'string' ? alerts.alert : alerts.alert.message}
                        </span>
                    </span>
                    <button
                        onClick={clearAlert}
                        className={styles['close-btn']}
                        aria-label="Close alert bar"
                    >
                        &times;
                    </button>
                </div>
            )}
            
            {alerts.error && (
                <div className={`${styles['info-bar']} ${styles['error-bar']}`}>
                    <span className={styles['alert-content']}>
                        {alerts.error.icon && <span className={styles['alert-icon']}>{alerts.error.icon}</span>}
                        <span className={styles['alert-message']}>
                            {typeof alerts.error === 'string' ? alerts.error : alerts.error.message}
                        </span>
                    </span>
                    <button
                        onClick={clearErrorAlert}
                        className={styles['close-btn']}
                        aria-label="Close error bar"
                    >
                        &times;
                    </button>
                </div>
            )}
        </div>
    );
};

export default AlertContainer;
